import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

export default function MainMenu() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch("https://spst.in/myapp/api/logout.php", {
                method: "POST",
            });

            // ❗ Remove authentication
            localStorage.removeItem("auth");

            // 🔴 Trigger logout in all tabs
            localStorage.setItem("logout", Date.now());

            // Redirect to login
            navigate("/");

        } catch (error) {
            console.error("Logout failed:", error);
        }
    };


    return (
        <div>

            <div class="row" style={{ background: 'orange_' }}>
                <div className="container_ containeritems" >
                    <div className="boxes">
                        <NavLink to="../Dashboard" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-tachometer" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Dashboard</span></NavLink>
                    </div>
                    <div className="boxes">
                        <NavLink to="../Newprofile" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-address-book-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">New Student </span></NavLink>
                    </div>  
                    <div className="boxes">
                        <NavLink to="../Batch" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-address-book-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Manage Batch </span></NavLink>
                    </div> 
                    <div className="boxes">
                        <NavLink to="../Course" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-address-book-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Manage Course </span></NavLink>
                    </div> 
                    <div className="boxes">
                        <NavLink to="../Visiting" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-rupee" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Fee Collection</span></NavLink>
                    </div>
                    <div className="boxes">
                        <NavLink to="../ManageStudent" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-graduation-cap" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Manage Students</span></NavLink>
                    </div>
                    {/* <div className="boxes">
                        <NavLink to="../General" className={({ isActive }) =>
                            isActive ? "menuitems activeBox" : "menuitems"}> <i class="fa fa-file-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Print Other Info</span></NavLink>
                    </div> */}
                    {/* <div className="boxes">
                        <a to="" className="menuitems"
                            onClick={() => {
                                window.open("https://astro.cubixsystems.com/api/download.php");
                            }}
                            >
                            <i class="fa fa-download" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px'}}></i> <span className="menuitems">Download Bakcup</span>
                        </a>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../advancedsearch" className="menuitems" ><i class="fa fa-file" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Reports</span></Link>
                    </div>
                    <div className="boxes">
                        <Link to="../collectionreport" className="menuitems" ><i class="fa fa-rupee" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Collection Reports</span></Link>
                    </div>
                    <div className="boxes">
                        <Link to="../Searchprofile" className="menuitems" ><i class="fa fa-users" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Search Profile</span></Link>
                    </div> */}






                    {/* <div className="boxes">
                        <Link to="../DarsanTime" className="menuitems" ><i class="fa fa-clock-o" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Darsan Time</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Notices" className="menuitems"><i class="fa fa-cloud" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <span className="menuitems">Updates</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Updates" className="menuitems"><i class="fa fa-cloud" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Updates</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Photo" className="menuitems"><i class="fa fa-image" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span className="menuitems">Gallery</span></Link>
                    </div> */}
                    {/* <div className="boxes">
                        <Link to="../Register" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-home" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Register</p></Link>
                    </div> */}
                    <div className="boxes">
                        <span className="menuitems">
                            <i class="fa fa-power-off" aria-hidden="true" style={{ fontSize: '15pt', marginBottom: '00px' }}></i>
                            <span
                                onClick={handleLogout}
                                className="menuitems">
                                Exit
                            </span>
                        </span>

                    </div>
                </div>
            </div>
        </div>
    );
}
